import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getTemplateConfig = createAsyncThunk("templateConfig/getTemplateConfig", async () => {
  try {
    const response = await magnifiAPI.getTemplateConfig();

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateTemplateConfig = createAsyncThunk("templateConfig/updateTemplateConfig", async (payload) => {
  try {
    const response = await magnifiAPI.updateTemplateConfig(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
